import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    margin: theme.spacing(2, 0),
  },
  textField: {
    padding: theme.spacing(1),
    "& .MuiOutlinedInput-root": {
      border: "none",
      borderBottom: `1px solid ${theme.palette.primary.light}`,
      borderRadius: 0,
      "&:hover": {
        borderBottom: `1px solid ${theme.palette.primary.main}`,
      },
      "&.Mui-focused": {
        borderBottom: `1px solid ${theme.palette.primary.main}`,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "0px 0px 10px 0px",
      textAlign: "left",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  icon: {
    color: theme.palette.secondary.main,
  },
}));
